import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { asignarPDFEscrituraComponent } from './asignarPDFEscritura.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'asignarPDFEscritura',
        component: asignarPDFEscrituraComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'asignarPDFEscritura',
          nombreFormulario : 'asignar PDF Escritura'
        } 
    }
];

@NgModule({
    declarations: [
        asignarPDFEscrituraComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        asignarPDFEscrituraComponent
    ],
    bootstrap: [asignarPDFEscrituraComponent]
})

export class asignarPDFEscrituraModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearEscritura/asignarPDFEscritura.module.ts